<template>
    <div class="footer_text">
        <p class="text">
            <el-link :underline="false" href="#/aboutHQ">关于和峰</el-link>
            <el-divider direction="vertical"></el-divider>
<!--            <el-link :underline="false" href="#/newsHQ">新闻动态</el-link>
            <el-divider direction="vertical"></el-divider>-->
            <el-link :underline="false" href="#/joinHQ">招募精英</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link :underline="false" href="#/contactUs">联系我们</el-link>
            <span style="font-size: 0.5rem;color: #cccccc;display: none;">当前版本：{{ version }}</span>
        </p>
        <p class="text2">北京和峰科技有限公司 版权所有 京ICP备18007772号</p>
        <p class="text2 text3">Copyright © 2026    和峰科技</p>

    </div>
</template>

<script>
    export default {
        name: "Footer",
        data () {
            return {
                version:this.$version
            }
        }
    }
</script>

<style scoped>
    .footer_text{
        padding-top: 1.2rem;
    }
    .footer_text p{
        line-height: 1.5rem;
    }
    .footer_text .text{
        color: #ffffff;
        margin: 0 0 0.5rem 0 !important;
    }
    .el-link.el-link--default{
        color: #ffffff;
        font-family: AlibabaPuHuiTi-Bold !important;
        font-size: 1rem;
    }
    .text2{
        font-family: AlibabaPuHuiTi;
        margin: 0 !important;
        color: #888888;
        font-size: 0.875rem;
    }
    .text3{
        font-size: 0.75rem;
    }

</style>
